import {
  AiCategoryRecommendItem,
  GET_AI_CATEGORY_RECOMMEND,
} from '@/api/MaterialApi'
import { selectNodeParam } from '@/components/TreeAll'

export const fetchAiCategoryRecommendations = async (
  materialName: string,
  description?: string,
) => {
  const res = await GET_AI_CATEGORY_RECOMMEND({ materialName, description })
  if (res.code !== 0 || !Array.isArray(res.data)) {
    throw new Error('Invalid AI category recommendation response')
  }
  return res.data
}

export const getHighestConfidenceRecommendation = (
  recommendations: AiCategoryRecommendItem[],
  minimumConfidence: number,
) =>
  recommendations.reduce<AiCategoryRecommendItem | undefined>(
    (highest, item) => {
      const confidence = Number(item.confidence)
      if (confidence < minimumConfidence) return highest
      if (!highest || confidence > Number(highest.confidence)) return item
      return highest
    },
    undefined,
  )

export const toCategorySelectNodeParam = (
  item: AiCategoryRecommendItem,
): selectNodeParam => ({
  key: item.categoryId,
  title: item.categoryName,
  level: '4',
  parentId: item.parentId || '',
  categoryTree: item.categoryTree,
  canAddProduct: true,
  prefixCode: item.categoryCode,
})
import {
  AiCategoryRecommendItem,
  GET_AI_CATEGORY_RECOMMEND,
} from '@/api/MaterialApi'
import { selectNodeParam } from '@/components/TreeAll'

export const fetchAiCategoryRecommendations = async (
  materialName: string,
  description?: string,
) => {
  const res = await GET_AI_CATEGORY_RECOMMEND({ materialName, description })
  if (res.code !== 0 || !Array.isArray(res.data)) {
    throw new Error('Invalid AI category recommendation response')
  }
  return res.data
}

export const getHighestConfidenceRecommendation = (
  recommendations: AiCategoryRecommendItem[],
  minimumConfidence: number,
) =>
  recommendations.reduce<AiCategoryRecommendItem | undefined>(
    (highest, item) => {
      const confidence = Number(item.confidence)
      if (confidence < minimumConfidence) return highest
      if (!highest || confidence > Number(highest.confidence)) return item
      return highest
    },
    undefined,
  )

export const toCategorySelectNodeParam = (
  item: AiCategoryRecommendItem,
): selectNodeParam => ({
  key: item.categoryId,
  title: item.categoryName,
  level: '4',
  parentId: item.parentId || '',
  categoryTree: item.categoryTree,
  canAddProduct: true,
  prefixCode: item.categoryCode,
})
